<template>
  <div :class="{...rowCSSClass}">
    <label v-if="inputLabel" :for="id">{{ inputLabel }} <small v-if="required">*</small></label>
    <div class="col-lg-12">
      <div class="mb-1" v-for="(value, index) in input" :key="index+'_address'">
        <div v-if="index > 0">
          <button type="button" class="btn btn-primary remove" @click="removeItem($event, index)">{{ computedLabels.removeLabel }}</button>
        </div>
        <Address 
          :id="id+'_'+index" 
          v-bind:value.sync="input[index]"
          :options="computedOptions"
          :labels="computedLabels"
         :labelAsColumn="labelAsColumn"
        />
      </div>
      <div v-if="nbItemsToAdd > 0" class="mt-1">
        <button type="button" class="btn btn-primary add" @click="addItem">{{ computedLabels.addLabel }}</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import GenericInput from '../../mixins/GenericInput.vue';
import Address, { AddressInput, AddressLabels, AddressOptions, getAddressDefaultLabels, getAddressDefaultOptions, getEmptyAddress } from './Address.vue';

export interface ListAddressesOptions extends AddressOptions {
  maxFields?:number;
}

export interface ListAddressesLabels extends AddressLabels {
  removeLabel:string;
  addLabel:string;
}

@Component({
  components : {
    Address
  }
})
export default class ListAddresses extends mixins<GenericInput<AddressInput[]>>(GenericInput) {

  @Prop({
    type: Object,
    required: false,
  }) readonly options!: ListAddressesOptions | undefined

  @Prop({
    type: Object,
    required: false,
  }) readonly labels!: AddressLabels | undefined

  computedOptions:ListAddressesOptions = {
    ...getAddressDefaultOptions(),
    maxFields:-1,
    ...this.options
  };

  input:any = this.value !== undefined ? this.value : [];

  get computedLabels():ListAddressesLabels {
    return {
      ...getAddressDefaultLabels(this),
      "removeLabel" : this.getLocalizedText({
        "fr" : "Supprimer",
        "en" : "Remove"
      }),
      "addLabel" : this.getLocalizedText({
        "fr" : "Ajouter une adresse",
        "en" : "Add an address"
      }),
      ...this.labels
    }
  }

  get nbItemsToAdd() {
    if(this.computedOptions.maxFields! <= 0) { return 1; }
    return this.computedOptions.maxFields! - this.input.length;
  }

  get inputLabel() {
    return (this.label && this.label != "") ? this.label : "";
  }

  addItem(evt:Event) {
    // We prevent submit of the page
    evt.preventDefault();

    this.input.push(getEmptyAddress(this.computedOptions.nbAddressLines));
  }

  removeItem(evt:Event, index:number) {
    // We prevent submit of the page
    evt.preventDefault();
    // We update the table
    this.input.splice(index, 1);
  }
  
}
</script>